import React, { useState } from 'react'
import PageBanner from "app/components/ui/PageBanner"
import SiteGrid from "app/components/ui/SiteGrid"
import HelmetTitle from "app/meta/HelmetTitle"
import './styles/ContactPage.css'
import { AppInput, AppTextarea } from "app/components/ui/AppInputs"
import AppButton from "app/components/ui/AppButton"
import { isEmptyText, validateEmail, validatePhone } from "app/utils/generalUtils"
import MapIframe from "app/components/ui/MapIframe"
import contactImg from 'app/assets/images/contact-img-1.jpg'

export default function ContactPage() {

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [message, setMessage] = useState('')
  const [nameError, setNameError] = useState("")
  const [emailError, setEmailError] = useState("")
  const [phoneError, setPhoneError] = useState("")
  const [messageError, setMessageError] = useState("")

  const formIsValid = !isEmptyText(name)
    && validateEmail(email)
    && validatePhone(phone)
    && !isEmptyText(message)

  const validateForm = () => {
    if (isEmptyText(name)) {
      setNameError("Name is required")
    }
    if (!validateEmail(email)) {
      setEmailError("Email is invalid")
    }
    if (!validatePhone(phone)) {
      setPhoneError("Phone is invalid")
    }
    if (isEmptyText(message)) {
      setMessageError("Message is required")
    }
  }

  const handleSubmit = () => {
    validateForm()
    if (formIsValid) {
      return alert('Form Valid!')
    }
  }

  return (
    <div className="contact-page">
      <HelmetTitle title="Contact" />
      <PageBanner
        title="Contact"
        subtitle="Let's Talk healthcare: Connect with Us for Your healthcare Needs"
      />
      <div className="page-content">
        <SiteGrid>
          <div className="contact-grid">
            <div className="img-container">
              <img src={contactImg} alt="contact" />
            </div>
            <div className="form-container">
              <div className="text-container">
                <h6>Contact Us</h6>
                <h2>Let's Connect</h2>
                <p>
                  We're here to answer your questions and assist you with
                  anything you need. Please use the contact form or information
                  provided to get in touch with us. We look forward to hearing
                  from you!
                </p>
              </div>
              <form onSubmit={(e) => e.preventDefault()}>
                <AppInput
                  label="Full Name*"
                  onChange={e => {
                    setName(e.target.value)
                    setNameError("")
                  }}
                  value={name}
                  subtext={<small>{nameError}</small>}
                />
                <AppInput
                  label="Email Address*"
                  onChange={e => {
                    setEmail(e.target.value)
                    setEmailError("")
                  }}
                  value={email}
                  subtext={<small>{emailError}</small>}
                />
                <AppInput
                  label="Phone*"
                  onChange={e => {
                    setPhone(e.target.value)
                    setPhoneError("")
                  }}
                  value={phone}
                  subtext={<small>{phoneError}</small>}
                />
                <AppTextarea
                  label="Message*"
                  onChange={e => {
                    setMessage(e.target.value)
                    setMessageError("")
                  }}
                  value={message}
                  className="message-textarea"
                  subtext={<small>{messageError}</small>}
                />
                <AppButton
                  label="Send Message"
                  onClick={handleSubmit}
                />
              </form>
            </div>
          </div>
        </SiteGrid>
        <SiteGrid>
          <div className="info-section">
            <div className="info-container">
              <h6>Our Office</h6>
              <span>
                <i className="fas fa-map-marker-alt" />
                734 W. 7th Street, Suite 100<br />Los Angeles, CA 90017
              </span>
            </div>
            <div className="info-container">
              <h6>Business Phone</h6>
              <span>
                <i className="fas fa-phone-alt" />
                +1 (213) 784-2937
              </span>
            </div>
            <div className="info-container">
              <h6>Business Email</h6>
              <span>
                <i className="fas fa-envelope" />
                <a href="mailto:info@aphrodite.com">info@aphrodite.com</a>
              </span>
              <span>
                <i className="fas fa-envelope" />
                <a href="mailto:contact@aphrodite.com">contact.aphrodite.com</a>
              </span>
            </div>
          </div>
        </SiteGrid>
        <MapIframe height="500px" />
      </div>
    </div>
  )
}
